/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCommitmentHistory.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/commitment-history";

export class AutogenModelCommitmentHistory<RowType extends ModelRow> extends Endpoint<RowType, RowCommitmentHistoryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCommitmentHistory extends ModelRow<RowCommitmentHistoryFields> {
	constructor(values?: Partial<RowCommitmentHistoryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCommitmentHistoryFields {
	commitment_id: string;
	company_id: string;
	customer_id: string;
	date_order_created: Date;
	date_tender_accepted: Date;
	date_tender_declined: Date;
	date_tender_received: Date;
	decline_reason: string;
	id: string;
	load_tender_id: string;
	order_id: string;
	orig_dest_rate_id: string;
	rate: string;
	rate_id: number;
	rate_type: string;
}

